import { DateTime } from "luxon";
import { fromObject } from "./date";

// The recent "to review" era starts this many days before Jan 1 of the
// current year; everything older is backlog. A fixed calendar cutoff keeps
// the split predictable — gaps between unallocated items don't move it.
const CUTOFF_LEAD_DAYS = 90;

// Shared by the server's inbox summary and the frontend's review list so
// "recent" means the same thing on both sides. The year comes from the UTC
// clock (not the machine's local zone) so a browser and the server can't
// disagree about which year it is around New Year.
export const backlogCutoff = (): DateTime =>
  fromObject({ year: DateTime.utc().year, month: 1, day: 1 }).minus({
    days: CUTOFF_LEAD_DAYS,
  });
